// extracted by mini-css-extract-plugin
export default {"borderGrey":"#b5b4b5","zIndexModalBackdrop":"1040","question":"Q2yZX6GSGqN0F9rY","text":"NKqq_n7rVDI3GYYb"};